import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from './global.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestServices {

  constructor(
    private http: HttpClient//,
    //private global: GlobalService //this depricated JW
  ) { }

  public postRequest(url, body): Observable<any> {
    return this.http.post(environment.apiUrl + url, body);
  }

  public postRequestwithfile(url, formdata): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    });

    let options = { headers: headers };

    return this.http.post(
      environment.apiUrl + url,
      formdata,
      options
    );
  }

  public getRequest(URL: any): Observable<any> {
    return this.http.get(environment.apiUrl + URL);
  }
}